/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  InviteUserRequest,
  RegisterDeviceTokenRequest,
} from '../models/index';
import {
    InviteUserRequestFromJSON,
    InviteUserRequestToJSON,
    RegisterDeviceTokenRequestFromJSON,
    RegisterDeviceTokenRequestToJSON,
} from '../models/index';

export interface InviteUserOperationRequest {
    inviteUserRequest: InviteUserRequest;
}

export interface RegisterDeviceTokenOperationRequest {
    registerDeviceTokenRequest: RegisterDeviceTokenRequest;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     */
    async inviteUserRaw(requestParameters: InviteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['inviteUserRequest'] == null) {
            throw new runtime.RequiredError(
                'inviteUserRequest',
                'Required parameter "inviteUserRequest" was null or undefined when calling inviteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteUserRequestToJSON(requestParameters['inviteUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async inviteUser(requestParameters: InviteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.inviteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async registerDeviceTokenRaw(requestParameters: RegisterDeviceTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['registerDeviceTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'registerDeviceTokenRequest',
                'Required parameter "registerDeviceTokenRequest" was null or undefined when calling registerDeviceToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/device-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterDeviceTokenRequestToJSON(requestParameters['registerDeviceTokenRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async registerDeviceToken(requestParameters: RegisterDeviceTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerDeviceTokenRaw(requestParameters, initOverrides);
    }

}
